import { render, staticRenderFns } from "./form-switch.vue?vue&type=template&id=1cdb8b66&scoped=true&"
import script from "./form-switch.vue?vue&type=script&lang=js&"
export * from "./form-switch.vue?vue&type=script&lang=js&"
import style0 from "./form-switch.vue?vue&type=style&index=0&id=1cdb8b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdb8b66",
  null
  
)

export default component.exports